import { useMouseDownEventSignal } from '../../../rx/signal/useMouseDownEventSignal'
import { useMouseDragList } from '../../../rx/use/useMouseDragList'
import { Engine } from '../../core/engine/Engine.type'
import onElementEvent from '../../onElementEvent'
import usePointerRefVector2 from '../../three/fn/usePointerRefVector2'

export default function registerPointerMoveEvent(
  engine: Engine,
  elem: HTMLElement
) {
  const pointerRef = usePointerRefVector2(engine)
  const [getMouseDownEvent] = useMouseDownEventSignal(engine)
  const mouseDragList = useMouseDragList(engine)

  function onPointerMove(event: MouseEvent) {
    // console.log('onPointerMove', event, window.innerWidth, window.innerHeight, elem)

    const {
      offsetX, offsetY,
      // buttons,
      // movementX, movementY,
    } = event

    const pointerX = (offsetX / (elem as HTMLCanvasElement).clientWidth) * 2 - 1
    const pointerY = - (offsetY / (elem as HTMLCanvasElement).clientHeight) * 2 + 1

    pointerRef.x = pointerX
    pointerRef.y = pointerY

    if (getMouseDownEvent()) {
      mouseDragList.push(event)
    }
  }

  // onWindowEvent('pointermove', onPointerMove)
  onElementEvent(elem, 'pointermove', onPointerMove)
}
